import React, { useEffect, useState } from 'react';
import Main from '../Main';
import { Box } from '@mui/material';
import DataTable from '../Table/DataTable';
import { buyersColumns } from '../Table/TableColumns';
import { useDispatch, useSelector } from 'react-redux';
import { getAllBuyer } from '../../../Redux/BuyerRedux.js';
import AddBuyers from './AddBuyers.js';

function Buyers() {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem('user'));
  const { allBuyer } = useSelector((state) => state.buyerRedux);
  const [showForm, setShowForm] = useState(
    localStorage.getItem('showForm') === 'true' ? true : false
  );
  const [viewMode, setViewMode] = useState(false);

  useEffect(() => {
    localStorage.setItem('showForm', 'false');
    dispatch(getAllBuyer(user.userId));
    const isViewMode = localStorage.getItem('vM');
    if (isViewMode === 'true') {
      setViewMode(true);
    } else {
      setViewMode(false);
    }
  }, [dispatch, user.userId, showForm]);

  // const handleButtonClick = () => {
  //   localStorage.setItem('vM', 'false');
  //   const newShowForm = !showForm;
  //   setShowForm(newShowForm);
  //   localStorage.setItem('showForm', newShowForm.toString());
  // };

  const rows = Array.isArray(allBuyer)
    ? allBuyer.map((buyer, index) => {
        return {
          id: buyer._id,
          sNo: index + 1,
          firstName: buyer.firstName,
          lastName: buyer.lastName,
          displayName: buyer.displayName,
          gender: buyer.gender,
          emailId: buyer.emailId,
          phoneNumber: buyer.phoneNumber,
          isActive: buyer.isActive === true ? 'Yes' : 'No',
        };
      })
    : [];

  return (
    <Main>
      <Box component='main' sx={{ flexGrow: 1, p: 3 }}>
        <div className='container border p-4'>
          <div className='row mt-3'>
            <div className='col-md-12'>
              {showForm ? (
                <AddBuyers setShowForm={setShowForm} />
              ) : (
                <div className='row mt-3'>
                  <div className='col-md-12'>
                    <DataTable
                      rows={rows}
                      setShowForm={setShowForm}
                      columns={buyersColumns}
                      tableType='buyer'
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Box>
    </Main>
  );
}

export default Buyers;
